<template>
  <div id="GuestDataCheck_main">
    <el-dialog
      v-loading="loading"
      :visible.sync="dialogVisible"
      custom-class="guestDataCheck"
      :close-on-click-modal="false"
      width="60%"
    >
      <div
        slot="title"
        class="title"
      >
        <span v-if="editMode">訪客資料修改</span>
        <span v-else>訪客資料確認</span>
      </div>
      <el-form
        label-position="left"
        label-width="130px"
        :class="editMode?'editMode':''"
      >
        <el-form-item
          label="訪客事由"
          class="redStart"
        >
          <div v-if="editMode">
            <el-select
              v-model="data.CauseTypeName"
              placeholder="請選擇訪客事由"
              @change="selectCauseType()"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </div>
          <span v-else>{{ data.CauseTypeName }}</span>
        </el-form-item>
        <el-form-item label="拜訪戶別">
          <el-button
            v-if="editMode"
            round
            @click="householdSwitch=true;isEdited=true"
          >
            {{ data.TabletNote || $t('Household.SelectHousehold') }}
          </el-button>
          <span v-else>{{ data.TabletNote }}</span>
        </el-form-item>
        <el-form-item
          label="訪客／廠商名稱"
          class="redStart"
        >
          <el-input
            v-if="editMode"
            v-model="data.GuestName"
            :class="!formRule.GuestName?'inputWarning':''"
            maxlength="20"
            placeholder="請輸入訪客／廠商名稱"
            @input="checkFormRule('訪客名稱')"
          />
          <span v-else>{{ data.GuestName }}</span>
        </el-form-item>
        <el-form-item label="電話號碼">
          <el-input
            v-if="editMode"
            v-model="data.CellPhone"
            placeholder="請輸入電話號碼"
            onkeyup="value=value.replace(/[^\d]/g,'')"
            maxlength="10"
            class="inputNumber"
            :class="!formRule.CellPhone?'inputWarning':''"
            @input="checkFormRule('電話號碼')"
          />
          <span v-else>{{ data.CellPhone }}</span>
        </el-form-item>
        <el-form-item :label="$t('Guest.LicensePlateNumber')">
          <el-input
            v-if="editMode"
            v-model="data.LicensePlateNumber"
            :placeholder="`${$t('Guest.PleaseEnter') + $t('Guest.LicensePlateNumber')}`"
            maxlength="8"
            @input="checkFormRule($t('Guest.LicensePlateNumber'))"
          />
          <span v-else>{{ data.LicensePlateNumber }}</span>
        </el-form-item>
        <el-form-item label="備註">
          <el-input
            v-if="editMode"
            v-model="data.Remark"
            type="textarea"
            placeholder="請輸入備註"
            maxlength="30"
            :autosize="{ minRows: 2 }"
            @input="isEdited=true"
          />
          <span v-else>{{ data.Remark }}</span>
        </el-form-item>
      </el-form>
      <el-divider :class="editMode?'editMode':''" />
      <div
        v-if="editMode"
        class="tip"
      >
        <el-button
          id="primaryButton"
          type="primary"
          round
          @click="closeEditMode()"
        >
          儲存修改
        </el-button>
      </div>
      <div
        v-else
        class="tip"
      >
        <p>
          請確認訪客資料是否正確，若有缺漏，請按
          <span @click="editMode = true">修改資料</span>
        </p>
        <el-button
          id="primaryButton"
          type="primary"
          round
          @click="closeDialog()"
        >
          確認資料，下一步
        </el-button>
      </div>
    </el-dialog>
    <HouseholdFrame
      :open.sync="householdSwitch"
      @select-household="selectedHousehold"
    />
  </div>
</template>
<script>
import HouseholdFrame from '@/components/HouseholdFrame'
import { isValidCellphone, isValidCellphoneNotContainZero } from '@/js/utils/unitValidate'
import { formatLicensePlateNumber } from '@/js/utils/guest'

export default {
  components: {
    HouseholdFrame
  },
  data () {
    return {
      dialogVisible: false,
      guestId: '',
      data: {
        CauseTypeId: 0,
        GuestName: '',
        CellPhone: '',
        CauseTypeName: '',
        LicensePlateNumber: '',
        Remark: ''
      },
      formRule: {
        GuestName: true,
        CellPhone: true
      },
      options: [],
      editMode: false,
      householdSwitch: false,
      householdValue: '',
      isEdited: false, // 紀錄是否有編輯過
      loading: false
    }
  },
  methods: {
    async openDialog (guestId) {
      this.loading = true
      this.guestId = guestId
      await this.getData()
      this.getGuestCauseList()
      this.dialogVisible = true
    },
    // 取得訪客資料
    getData () {
      const queryPath = {
        id: this.guestId
      }
      return new Promise((resolve, reject) => {
        apiGuest.PlusGuestReservation.GetGuestData(queryPath).then((res) => {
          if (res.status === 200) {
            this.data = {
              CauseTypeName: res.data.CauseTypeName,
              TabletNote: res.data.TabletNote,
              GuestName: res.data.GuestName,
              CellPhone: res.data.CellPhone,
              LicensePlateNumber: res.data.LicensePlateNumber,
              Remark: res.data.Remark
            }
            this.householdValue = res.data.TabletId
          }
          if (res.data.GuestStatusId === 3) {
            this.$alert(this.$t('Guest.DuplicateGuestDataNoActionRequired'), this.$t('General.Error'), {
              confirmButtonText: this.$t('General.OK'),
              type: 'error'
            }).then(() => {
              window.opener = null
              window.close()
            }).catch(() => {})
          }
          this.loading = false
          resolve()
        }).catch((err) => {
          reject(new Error('取得訪客資料失敗'))
          console.log('錯誤訊息：', err.response)
        })
      })
    },
    // 取得訪客事由列表
    getGuestCauseList () {
      apiGuest.SetUpDialog.GetGuestCauseType().then((res) => {
        res.data.forEach(item => {
          this.options.push(
            {
              value: item.Id,
              label: item.Name
            }
          )
        })
        this.loading = false
        this.options.forEach(item => {
          if (item.label === this.data.CauseTypeName) { this.data.CauseTypeId = item.value }
        })
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 儲存修改 button
    closeEditMode () {
      document.getElementById('primaryButton').blur()
      let errText = ''
      if (!this.formRule.GuestName) { errText += '請輸入訪客／廠商名稱 ' }
      if (!this.formRule.CellPhone) { errText += '電話號碼格式錯誤' }
      if (errText !== '') {
        this.$alert(errText, '錯誤', {
          confirmButtonText: '確定',
          type: 'error',
          callback: action => {}
        })
      } else if (this.isEdited) {
        this.editMode = false
        this.editGuest()
      } else {
        this.editMode = false
      }
    },
    // 修改資料API
    editGuest () {
      const queryPath = {
        id: this.guestId
      }
      const requestData = {
        causeTypeId: this.data.CauseTypeId,
        guestName: this.data.GuestName,
        tabletId: this.householdValue,
        remark: this.data.Remark,
        cellPhone: this.data.CellPhone = this.data.CellPhone === null ? '' : this.data.CellPhone,
        licensePlateNumber: this.data.LicensePlateNumber
      }
      apiGuest.PlusGuestReservation.PatchEditGuestData(
        queryPath,
        requestData
      ).then((res) => {
        console.log(res.data)
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 確認資料，下一步
    closeDialog () {
      this.$emit('siteGuestArrived', this.guestId)
    },
    // 欄位輸入限制
    checkFormRule (item) {
      this.isEdited = true
      if (item === '訪客名稱') {
        this.formRule.GuestName = this.data.GuestName !== ''
      } else if (item === '電話號碼') {
        if (isValidCellphone(this.data.CellPhone)) {
          this.formRule.CellPhone = true
        } else if (isValidCellphoneNotContainZero(this.data.CellPhone)) {
          this.data.CellPhone = `0${this.data.CellPhone}` // 開頭未輸入0,自動補0
          this.formRule.CellPhone = true
        } else if (this.data.CellPhone === '') { // 因為非必填
          this.formRule.CellPhone = true
        } else {
          this.formRule.CellPhone = false
        }
      } else if (item === this.$t('Guest.LicensePlateNumber')) {
        this.data.LicensePlateNumber = formatLicensePlateNumber(this.data.LicensePlateNumber)
      }
    },
    selectCauseType () {
      this.isEdited = true
      this.options.forEach(item => {
        if (item.label === this.data.CauseTypeName) { this.data.CauseTypeId = item.value }
      })
    },
    selectedHousehold (content) { // 已選擇戶別
      this.data.TabletNote = content.TabletNote
      this.householdValue = content.TabletId
      this.householdSwitch = false
    }
  }
}
</script>
<style lang="sass" scoped>
#GuestDataCheck_main
  width: 100%
  height: 100%
  .el-dialog__wrapper
    background-color: #808080
  ::v-deep .el-dialog.guestDataCheck
    +basicDialog
    margin-bottom: 0px
    overflow: auto
    min-width: 540px
    .title
      color: $mainFontColor
      font-size: map-get($fontSize,large)
      font-weight: bold
      line-height: 32px
    .el-icon-close
      &:before
        display: none
    .el-form
      text-align: left
      .el-form-item__label
        margin-right: 0px
        padding-right: 16px
        font-weight: bold
      span
        color: $mainFontColor
      .el-form-item
        font-size: 20px
        margin-bottom: 15px
        span
    .el-form.editMode
      .el-form-item__label
        line-height: 40px
      .el-form-item.redStart
        position: relative
        .el-form-item__label
          &::before
            position: absolute
            top: 0
            left: -10px
            content: "*"
            color: $dangerColor
    .el-select
      width: 100%
    .el-input
      // width: 320px
      font-size: 15px
      &.inputWarning
        .el-input__inner
          border: $dangerColorHover 1px solid
      &.inputNumber
        .el-input__inner
          line-height: 1px
        input::-webkit-outer-spin-button,input::-webkit-inner-spin-button
          -webkit-appearance: none
          margin: 0
    .el-divider
      color: $borderDark1
      margin-top: 10px
      &.editMode
        margin-top: 24px
        margin-bottom: 0px
    .tip
      text-align: center
      display: block
      margin: 0px auto
      p
        font-size: 15px
        line-height: 25px
        margin-bottom: 20px
      span
        color: $mainColorDark
        font-size: 15px
        cursor: pointer
        text-decoration: underline
      .el-button
        span
          color: $white
          text-decoration: none
  .household_frame
    ::v-deep .el-dialog
      max-width: 600px
</style>
